import { useQuery } from '@apollo/client';
import { GetObligationAssessmentResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { getAuditItems } from './auditEntityFinder';
import AuditViewComponent from './AuditViewComponent';
import type { AuditEntityRetrieverInput } from './types';

const ObligationAssessmentResultAudit = (input: AuditEntityRetrieverInput) => {
  const { data: result } = useQuery(
    GetObligationAssessmentResultAuditByIdDocument,
    {
      variables: {
        Id: input.id,
      },
    }
  );
  const { current, previous } = getAuditItems(
    result?.obligation_assessment_result_audit,
    input.operationDate
  );

  return (
    <AuditViewComponent
      operation={input.operation}
      current={JSON.stringify(current, null, 2)}
      previous={JSON.stringify(previous, null, 2)}
    />
  );
};

export default ObligationAssessmentResultAudit;
